/**
 * Discount Code Web Component
 * Handles copy-to-clipboard functionality for discount codes
 * Adapted from Enterprise theme for Warehouse/Klebemeister
 */

if (!customElements.get('discount-code')) {
  class DiscountCode extends HTMLElement {
    constructor() {
      super();
      this.discountCode = this.querySelector('.js-discount-code');
      this.discountCodeBtn = this.querySelector('.js-copy-button');
      this.copySuccess = this.querySelector('.js-copy-success');
      this.init();
    }

    init() {
      // Check if Clipboard API is available
      if (navigator.clipboard && navigator.clipboard.writeText) {
        this.discountCodeBtn.addEventListener('click', this.copyCode.bind(this));
        this.discountCode.addEventListener('click', this.copyCode.bind(this));
      } else {
        // Hide button if clipboard API not available
        this.discountCodeBtn.hidden = true;
      }
    }

    copyCode() {
      const discountCode = this.discountCode.textContent.trim();

      navigator.clipboard.writeText(discountCode).then(
        () => {
          // Success: show success message
          this.copySuccess.classList.add('is-visible');
          this.copySuccess.setAttribute('aria-hidden', 'false');

          // Start closing animation after 1.8s
          setTimeout(() => {
            this.copySuccess.classList.add('is-closing');
          }, 1800);

          // Remove all classes after 2s
          setTimeout(() => {
            this.copySuccess.classList.remove('is-closing');
            this.copySuccess.classList.remove('is-visible');
            this.copySuccess.setAttribute('aria-hidden', 'true');
          }, 2000);
        },
        () => {
          // Failure: show alert
          const errorMessage = this.getAttribute('data-copy-error') || 'Kopieren fehlgeschlagen. Bitte manuell kopieren.';
          alert(errorMessage);
        }
      );
    }
  }

  customElements.define('discount-code', DiscountCode);
}
